module.exports = __webpack_public_path__ + "static/avatar.3da9a11a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/jpg/avatar.jpg
// module id = 184
// module chunks = 114276838955818 198517197184460